import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";
import { useChannelEscalationStatus } from "hooks/useChannelEscalationStatus";
import { ModalControl, useModal } from "hooks/useModal";
import { useToast } from "hooks/useToast";
import {
  HUMAN_SUPPORT_STATUS,
  useResolveHumanSupportMutation,
} from "store/apis/chatHumanSupport";
import { BackendError } from "types/utils/error";

export const ResolveHumanSupport = () => {
  const confirmationModal = useModal();
  const { channelId, escalationStatus } = useChannelEscalationStatus();

  const { alertToast } = useToast();
  const [resolveHumanSupport, { isLoading: isResolvingSupport }] =
    useResolveHumanSupportMutation();

  const handleResolveRequest = async () => {
    try {
      await resolveHumanSupport({ channelId }).unwrap();
      confirmationModal.close();
    } catch (err) {
      alertToast({
        message: (err as BackendError).data?.error?.message,
      });
    }
  };

  if (escalationStatus === HUMAN_SUPPORT_STATUS.ACTIVE) {
    return (
      <>
        <Button
          customType="secondary"
          size="small"
          onClick={confirmationModal.open}
        >
          Resolve
        </Button>
        <ResolveConfirmation
          {...confirmationModal}
          onConfirm={handleResolveRequest}
          isLoading={isResolvingSupport}
        />
      </>
    );
  }

  return null;
};

const ResolveConfirmation = ({
  isOpen,
  close,
  onConfirm,
  isLoading,
}: ModalControl & { onConfirm: () => void; isLoading: boolean }) => {
  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content size="small">
        <StatusModal
          type="warning"
          title="Resolve this conversation?"
          showCloseButton={false}
        >
          Only resolve this conversation if the customer's issue has been
          addressed and they've confirmed their query is resolved.
        </StatusModal>
        <Modal.Footer className="t-flex t-justify-end t-gap-3">
          <Button onClick={close}>Go back</Button>
          <Button
            customType="primary"
            onClick={onConfirm}
            isLoading={isLoading}
            disabled={isLoading}
          >
            Yes, resolve
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Root>
  );
};
